import { Component } from '@theme/component';
import '@theme/product-form';
import '@theme/component-quantity-selector';

/**
 * Validates the pallet's freight contact before handing its unchanged form to
 * the native product component, which owns the request and cart update events.
 */
class ScPalletPurchase extends Component {
  /**
   * The theme delegates submit events at document capture, so the native form's
   * on:submit selector explicitly routes through this guard first.
   * @param {Event} event
   */
  handleSubmit(event) {
    event.preventDefault();

    const productForm = /** @type {(HTMLElement & {handleSubmit?: (event: Event) => void}) | null} */ (
      this.querySelector('product-form-component')
    );
    const form = productForm?.querySelector('form');
    if (!(form instanceof HTMLFormElement)) return;

    const phone = form.elements.namedItem('properties[Freight delivery phone]');
    if (!(phone instanceof HTMLInputElement)) return;

    phone.value = phone.value.trim();
    const parts = phone.value.match(/^(\+?[0-9() .-]+?)(?:\s*(?:ext\.?|x|#)\s*([0-9]{1,6}))?$/i);
    const digits = parts?.[1].replace(/\D/g, '') ?? '';
    const plausible = Boolean(parts) && digits.length >= 10 && digits.length <= 15;
    phone.setCustomValidity(plausible ? '' : 'Enter a full delivery phone number, including the area or country code.');
    if (!plausible) {
      phone.addEventListener('input', () => phone.setCustomValidity(''), { once: true });
    }
    if (!form.reportValidity()) return;

    productForm?.handleSubmit?.(event);
  }
}

if (!customElements.get('sc-pallet-purchase')) {
  customElements.define('sc-pallet-purchase', ScPalletPurchase);
}
